import { useFormik } from "formik";
import * as yup from "yup";
import { useEffect, useRef, useState } from "react";
import "./css/packages.css";
import InputMask from "react-input-mask";

import { complexDigitToman, convertPersian, validationMessage } from "../../tools/tools";
import { useAPIDirectCharge } from "../../tools/api";
import ModalConfirm from "./modal";
import { useCookies } from "react-cookie";
import { Link, useNavigate } from "react-router-dom";
import { _adr } from "../../address";
import { Helmet } from "react-helmet";
import LoadingPackagesColumn, { LoadingPackagesRows } from "./skeletonPackages";
const PackageIndex = () => {
	const mdb = window["mdb"];

	const {
		queryPackagesByPlanId,
		queryProductGroup,
		queryPackagesBySubGroup,
		queryGateWayByPlanId,
		queryPackage,
		queryEPMostPurchased,
		queryPromotionProducts,
		queryBestSellingEPPackages,
	} = useAPIDirectCharge();
	const nav = useNavigate();
	const [cookies, setCookie] = useCookies(["showGridPackage"]);
	const [category, setCategory] = useState([]);
	const [packages, setPackages] = useState([]);
	const [packagesOffers, setPackagesOffers] = useState([]);
	const [maxPage, setMaxPage] = useState(0);
	const [buttonShowMore, setButtonShowMore] = useState(false);
	const [page, setPage] = useState(0);
	const [showGrid, setShowGrid] = useState(cookies?.showGridPackage === "true" ? true : false);
	const [currentFilterActive, setCurrentFilterActive] = useState({
		id: "0",
		name: "",
	});
	const [orgPackages, setOrgPackages] = useState([]);
	const [activeMsisdn, setActiveMsisdn] = useState(false);
	const [choosePackage, setChoosePackage] = useState({});
	const [validRequestOrder, setValidRequestOrder] = useState(false);
	const [orderShow, setOrderShow] = useState([
		{ id: "0", name: "پیشنهاد آپتل" },
		{ id: "3", name: "پرفروش ترین بسته‌ها" },
	]);
	const [orderSelected, setOrderSelected] = useState({
		id: "0",
		name: "پیشنهاد آپتل",
	});
	const [isActiveOrder, setIsActiveOrder] = useState(false);

	const [isLoading, setIsLoading] = useState(true);

	const refCategoryScroll = useRef("");
	const formik = useFormik({
		initialValues: {
			msisdn: "",
		},
		validationSchema: yup.object({
			msisdn: yup
				.string()
				.required(validationMessage.required)
				.matches("^\\d{7}$", validationMessage.regex)
				.transform((value) => {
					return value.replace(/ /g, "");
				}),
		}),
		onSubmit: async (values) => {
			setIsLoading(true);
			setValidRequestOrder(false);
			let req = {
				msisdn: "0999" + formik.values.msisdn.replace(/ /g, "").replace(/_/g, ""),
				planid: process.env.REACT_APP_EP_PLANID,
			};
			let responseValid = await queryGateWayByPlanId(req);
			if (responseValid) {
				setOrderShow([
					{ id: "0", name: "پیشنهاد آپتل" },
					{ id: "1", name: "خریدهای قبلی" },
					// { id: "2", name: "بسته ویژه" },
					{ id: "3", name: "پرفروش ترین بسته‌ها" },
				]);
				setOrderSelected({ id: "0", name: "پیشنهاد آپتل" });
				setValidRequestOrder(true);
				setCurrentFilterActive({ id: 0, name: "" });
			}
		},
	});

	useEffect(() => {
		if (validRequestOrder) handleShowOrderPackages();
	}, [validRequestOrder]);

	const handleShowOrderPackages = async () => {
		debugger;
		setActiveMsisdn(false);
		setCurrentFilterActive({ id: 0, name: "" });
		//Show Prefer Aptel Packages
		if (orderSelected.id === "0") {
			let req = {
				msisdn: "0999" + formik.values.msisdn.replace(/ /g, "").replace(/_/g, ""),
				planid: process.env.REACT_APP_EP_PLANID,
			};

			let response = await queryPackage(req);
			if (response) {
				let groups = [];
				let subgroups = [];

				response.forEach((index) => {
					// Add group
					let groupIndex = groups.findIndex((item) => item.productGroupId === index.productGroupId);
					if (groupIndex === -1) {
						groups.push({
							productGroupId: index.productGroupId,
							productGroupName: index.productGroupName,
							productGroupOrderId: index.productGroupOrderId,
						});
					}

					// Add subgroup
					let subgroupIndex = subgroups.findIndex((item) => item.productSubGroupId === index.productSubGroupId);
					if (subgroupIndex === -1) {
						subgroups.push({
							productGroupId: index.productGroupId,
							productSubGroupId: index.productSubGroupId,
							productSubGroupName: index.productSubGroupName,
							productSubOrderId: index.productSubOrderId,
						});
					}
				});

				// Sort groups
				groups.sort((a, b) => a.productGroupOrderId - b.productGroupOrderId);

				// Sort subgroups
				subgroups.sort((a, b) => a.productSubOrderId - b.productSubOrderId);

				// Remove duplicate groups
				let uniqueGroupIds = new Set();
				let uniqueGroups = groups.filter((item) => {
					if (!uniqueGroupIds.has(item.productGroupId)) {
						uniqueGroupIds.add(item.productGroupId);
						return true;
					}
					return false;
				});

				// Remove duplicate subgroups
				let uniqueSubgroupIds = new Set();
				let uniqueSubgroups = subgroups.filter((item) => {
					if (!uniqueSubgroupIds.has(item.productSubGroupId)) {
						uniqueSubgroupIds.add(item.productSubGroupId);
						return true;
					}
					return false;
				});

				// Build categories
				let categories = uniqueGroups.map((group) => {
					let subgroup = uniqueSubgroups
						.filter((subgroup) => subgroup.productGroupId === group.productGroupId)
						.map((subgroup) => ({
							inT_ProductSubGroupId: subgroup.productSubGroupId,
							stR_ProductSubGroupName: subgroup.productSubGroupName,
						}));

					return {
						productGroupId: group.productGroupId,
						productGroupName: group.productGroupName,
						subgroup: subgroup,
					};
				});

				//Remove duplicate Package
				let uniquePackagesIds = new Set();
				let uniquePackages = response.filter((item) => {
					if (!uniquePackagesIds.has(item.packageId)) {
						uniquePackagesIds.add(item.packageId);
						return true;
					}
					return false;
				});

				uniquePackages = uniquePackages.sort((a, b) => {
					if (a.orderId > b.orderId) return 1;
					else return -1;
				});

				setCategory(categories);
				setOrgPackages(response);
				setPackages(uniquePackages);
				setIsLoading(false);
				setButtonShowMore(false);
				setActiveMsisdn(true);
			} else {
				setCategory([]);
				setOrgPackages([]);
				setPackages([]);
				setIsLoading(false);
				setButtonShowMore(false);
			}
		}
		//show preveus purchase packages
		if (orderSelected.id === "1") {
			let req = {
				msisdn: "0999" + formik.values.msisdn.replace(/ /g, "").replace(/_/g, ""),
				planid: process.env.REACT_APP_EP_PLANID,
			};

			let response = await queryEPMostPurchased(req);
			if (response) {
				let groups = [];
				let subgroups = [];

				response.forEach((index) => {
					// Add group
					let groupIndex = groups.findIndex((item) => item.productGroupId === index.productGroupId);
					if (groupIndex === -1) {
						groups.push({
							productGroupId: index.productGroupId,
							productGroupName: index.productGroupName,
							productGroupOrderId: index.productGroupOrderId,
						});
					}

					// Add subgroup
					let subgroupIndex = subgroups.findIndex((item) => item.productSubGroupId === index.productSubGroupId);
					if (subgroupIndex === -1) {
						subgroups.push({
							productGroupId: index.productGroupId,
							productSubGroupId: index.productSubGroupId,
							productSubGroupName: index.productSubGroupName,
							productSubOrderId: index.productSubOrderId,
						});
					}
				});

				// Sort groups
				groups.sort((a, b) => a.productGroupOrderId - b.productGroupOrderId);

				// Sort subgroups
				subgroups.sort((a, b) => a.productSubOrderId - b.productSubOrderId);

				// Remove duplicate groups
				let uniqueGroupIds = new Set();
				let uniqueGroups = groups.filter((item) => {
					if (!uniqueGroupIds.has(item.productGroupId)) {
						uniqueGroupIds.add(item.productGroupId);
						return true;
					}
					return false;
				});

				// Remove duplicate subgroups
				let uniqueSubgroupIds = new Set();
				let uniqueSubgroups = subgroups.filter((item) => {
					if (!uniqueSubgroupIds.has(item.productSubGroupId)) {
						uniqueSubgroupIds.add(item.productSubGroupId);
						return true;
					}
					return false;
				});

				// Build categories
				let categories = uniqueGroups.map((group) => {
					let subgroup = uniqueSubgroups
						.filter((subgroup) => subgroup.productGroupId === group.productGroupId)
						.map((subgroup) => ({
							inT_ProductSubGroupId: subgroup.productSubGroupId,
							stR_ProductSubGroupName: subgroup.productSubGroupName,
						}));

					return {
						productGroupId: group.productGroupId,
						productGroupName: group.productGroupName,
						subgroup: subgroup,
					};
				});

				//Remove duplicate Package
				let uniquePackagesIds = new Set();
				let uniquePackages = response.filter((item) => {
					if (!uniquePackagesIds.has(item.packageId)) {
						uniquePackagesIds.add(item.packageId);
						return true;
					}
					return false;
				});

				//sort packages
				let sortedPackage = uniquePackages.sort((a, b) => a.orderId - b.orderId);

				setCategory(categories);
				setOrgPackages(response);
				setPackages(sortedPackage);
				setIsLoading(false);
				setButtonShowMore(false);
				setActiveMsisdn(true);
			} else {
				setCategory([]);
				setOrgPackages([]);
				setPackages([]);
				setIsLoading(false);
			}
		}
		//show special package for subscription
		// if (orderSelected.id === "2") {
		if ("2" === "2") {
			let req = {
				msisdn: "0999" + formik.values.msisdn.replace(/ /g, "").replace(/_/g, ""),
				planid: process.env.REACT_APP_EP_PLANID,
			};

			let response = await queryPromotionProducts(req);
			if (response) {
				let groups = [];
				let subgroups = [];

				response.forEach((index) => {
					// Add group
					let groupIndex = groups.findIndex((item) => item.productGroupId === index.productGroupId);
					if (groupIndex === -1) {
						groups.push({
							productGroupId: index.productGroupId,
							productGroupName: index.productGroupName,
							productGroupOrderId: index.productGroupOrderId,
						});
					}

					// Add subgroup
					let subgroupIndex = subgroups.findIndex((item) => item.productSubGroupId === index.productSubGroupId);
					if (subgroupIndex === -1) {
						subgroups.push({
							productGroupId: index.productGroupId,
							productSubGroupId: index.productSubGroupId,
							productSubGroupName: index.productSubGroupName,
							productSubOrderId: index.productSubOrderId,
						});
					}
				});

				// Sort groups
				groups.sort((a, b) => a.productGroupOrderId - b.productGroupOrderId);

				// Sort subgroups
				subgroups.sort((a, b) => a.productSubOrderId - b.productSubOrderId);

				// Remove duplicate groups
				let uniqueGroupIds = new Set();
				let uniqueGroups = groups.filter((item) => {
					if (!uniqueGroupIds.has(item.productGroupId)) {
						uniqueGroupIds.add(item.productGroupId);
						return true;
					}
					return false;
				});

				// Remove duplicate subgroups
				let uniqueSubgroupIds = new Set();
				let uniqueSubgroups = subgroups.filter((item) => {
					if (!uniqueSubgroupIds.has(item.productSubGroupId)) {
						uniqueSubgroupIds.add(item.productSubGroupId);
						return true;
					}
					return false;
				});

				// Build categories
				let categories = uniqueGroups.map((group) => {
					let subgroup = uniqueSubgroups
						.filter((subgroup) => subgroup.productGroupId === group.productGroupId)
						.map((subgroup) => ({
							inT_ProductSubGroupId: subgroup.productSubGroupId,
							stR_ProductSubGroupName: subgroup.productSubGroupName,
						}));

					return {
						productGroupId: group.productGroupId,
						productGroupName: group.productGroupName,
						subgroup: subgroup,
					};
				});

				//Remove duplicate Package
				let uniquePackagesIds = new Set();
				let uniquePackages = response.filter((item) => {
					if (!uniquePackagesIds.has(item.packageId)) {
						uniquePackagesIds.add(item.packageId);
						return true;
					}
					return false;
				});

				uniquePackages = response.sort((a, b) => a.orderId - b.orderId)

				// setCategory(categories);
				// setOrgPackages(response);
				setPackagesOffers(uniquePackages);
				// setIsLoading(false);
				// setButtonShowMore(false);
				// setActiveMsisdn(true);
			} else {
				// setCategory([]);
				// setOrgPackages([]);
				// setPackages([]);
				// setIsLoading(false);
			}
		}
		//show best Selling Package
		if (orderSelected.id === "3") {
			let response = await queryBestSellingEPPackages();
			if (response) {
				let groups = [];
				let subgroups = [];

				response.forEach((index) => {
					// Add group
					let groupIndex = groups.findIndex((item) => item.productGroupId === index.productGroupId);
					if (groupIndex === -1) {
						groups.push({
							productGroupId: index.productGroupId,
							productGroupName: index.productGroupName,
							productGroupOrderId: index.productGroupOrderId,
						});
					}

					// Add subgroup
					let subgroupIndex = subgroups.findIndex((item) => item.productSubGroupId === index.productSubGroupId);
					if (subgroupIndex === -1) {
						subgroups.push({
							productGroupId: index.productGroupId,
							productSubGroupId: index.productSubGroupId,
							productSubGroupName: index.productSubGroupName,
							productSubOrderId: index.productSubOrderId,
						});
					}
				});

				// Sort groups
				groups.sort((a, b) => a.productGroupOrderId - b.productGroupOrderId);

				// Sort subgroups
				subgroups.sort((a, b) => a.productSubOrderId - b.productSubOrderId);

				// Remove duplicate groups
				let uniqueGroupIds = new Set();
				let uniqueGroups = groups.filter((item) => {
					if (!uniqueGroupIds.has(item.productGroupId)) {
						uniqueGroupIds.add(item.productGroupId);
						return true;
					}
					return false;
				});

				// Remove duplicate subgroups
				let uniqueSubgroupIds = new Set();
				let uniqueSubgroups = subgroups.filter((item) => {
					if (!uniqueSubgroupIds.has(item.productSubGroupId)) {
						uniqueSubgroupIds.add(item.productSubGroupId);
						return true;
					}
					return false;
				});

				// Build categories
				let categories = uniqueGroups.map((group) => {
					let subgroup = uniqueSubgroups
						.filter((subgroup) => subgroup.productGroupId === group.productGroupId)
						.map((subgroup) => ({
							inT_ProductSubGroupId: subgroup.productSubGroupId,
							stR_ProductSubGroupName: subgroup.productSubGroupName,
						}));

					return {
						productGroupId: group.productGroupId,
						productGroupName: group.productGroupName,
						subgroup: subgroup,
					};
				});

				//Remove duplicate Package
				let uniquePackagesIds = new Set();
				let uniquePackages = response.filter((item) => {
					if (!uniquePackagesIds.has(item.packageId)) {
						uniquePackagesIds.add(item.packageId);
						return true;
					}
					return false;
				});

				uniquePackages = uniquePackages.sort((a, b) => {
					if (a.orderId > b.orderId) return 1;
					else return -1;
				});

				setCategory(categories);
				setOrgPackages(response);
				setPackages(uniquePackages);
				setIsLoading(false);
				setButtonShowMore(false);
			} else {
				setCategory([]);
				setOrgPackages([]);
				setPackages([]);
				setIsLoading(false);
			}
		}
	};

	useEffect(() => {
		const handleChecker = async () => {
			if (isActiveOrder) {
				if (!(await formik.validateField("msisdn")) && orderSelected.id === "0") {
					setButtonShowMore(true);
					showCategories();
					showPackageWhitoutFilter();
				} else {
					handleShowOrderPackages();
				}
			}
		};
		handleChecker();
	}, [orderSelected]);

	const handleChangeOrder = async (e) => {
		e.preventDefault();
		if (!(await formik.validateField("msisdn")) && e.target.dataset.id === "0") setPage(0);
		setIsActiveOrder(true);
		setOrderSelected({
			id: e.target.dataset.id,
			name: e.target.dataset.name,
		});
	};

	useEffect(() => {
		setButtonShowMore(true);
		showCategories();
		showPackageWhitoutFilter();
	}, []);

	const showCategories = async () => {
		let response = await queryProductGroup();
		if (response) {
			let _temp = response.sort((a, b) => a.productGroupOrderId - b.productGroupOrderId);
			setCategory(_temp);
			scrollCategories();
		}
	};

	const showPackageWhitoutFilter = async () => {
		setCurrentFilterActive({ id: 0, name: "" });
		if (maxPage >= page) {
			let _reqPackage = {
				planid: process.env.REACT_APP_EP_PLANID,
				searchconfig: {
					sort: "",
					filter: "",
					entriesperpage: 9,
					page: page,
					totalrowcount: 0,
				},
			};
			setPage(page + 1);
			let response = await queryPackagesByPlanId(_reqPackage);
			if (response) {
				let _max = response?.searchconfigmodel?.totalrowcount ? response?.searchconfigmodel?.totalrowcount / 9 : 0 / 9;
				setMaxPage(_max);
				let _tempPackages = packages;
				_tempPackages = _tempPackages.concat(response.Result);

				let uniquePackagesIds = new Set();
				let uniquePackages = _tempPackages.filter((item) => {
					if (!uniquePackagesIds.has(item.packageId)) {
						uniquePackagesIds.add(item.packageId);
						return true;
					}
					return false;
				});

				uniquePackages = uniquePackages.sort((a, b) => {
					if (a.orderId > b.orderId) return 1;
					else return -1;
				});
				setPackages(uniquePackages);
				setIsLoading(false);
				// if (page === 0) {
				//   setPackages(response?.Result ? response?.Result : []);
				// } else {
				//   setPackages((prev) => [
				//     ...prev,
				//     ...(response?.Result ? response?.Result : []),
				//   ]);
				// }

				_max < page + 1 && setButtonShowMore(false);
			} else {
				setButtonShowMore(false);
			}
		}
	};

	const handleChangeFilter = async (e) => {
		if (activeMsisdn) {
			let _tPackages = orgPackages;
			_tPackages = _tPackages.filter((i, index) => {
				return i.productSubGroupId === parseInt(e.target.dataset.value);
			});
			_tPackages = _tPackages.sort((a, b) => {
				if (a.orderId > b.orderId) return 1;
				else return -1;
			});
			setPackages(_tPackages);
			setIsLoading(false);
		} else {
			let req = {
				subproductgroupid: e.target.dataset.value,
				planid: process.env.REACT_APP_EP_PLANID,
			};
			let response = await queryPackagesBySubGroup(req);
			response = response.sort((a, b) => {
				if (a.orderId > b.orderId) return 1;
				else return -1;
			});
			setPackages(response ? response : []);
			setIsLoading(false);
			setButtonShowMore(false);
		}
		setCurrentFilterActive({
			id: e.target.dataset.value,
			name: e.target.dataset.name,
		});
	};

	const handleChoosePackage = async (e) => {
		let _Package = JSON.parse(e.target.dataset.object);
		if (_Package?.promotionId) {
			let obj = JSON.parse(e.target.dataset.object);
			setChoosePackage(obj);
			let popConfirm = document.getElementById("modalConfirmPackage");
			new mdb.Modal(popConfirm).show();
		} else {
			if (!formik.values.msisdn || !validRequestOrder) {
				let obj = JSON.parse(e.target.dataset.object);
				setChoosePackage(obj);
				let popConfirm = document.getElementById("modalConfirmPackage");
				new mdb.Modal(popConfirm).show();
			} else {
				nav(_adr.Root + _adr.Packages + _adr.PackagePrefactor, {
					state: {
						packages: JSON.parse(e.target.dataset.object),
						msisdn: formik.values.msisdn,
					},
				});
			}
		}
	};

	const scrollCategories = () => {
		const container = refCategoryScroll.current;
		let isDown = false;
		let startX;
		let scrollLeft;

		// For desktop
		container.addEventListener("mousedown", (e) => {
			isDown = true;
			startX = e.pageX - container.offsetLeft;
			scrollLeft = container.scrollLeft;
			container.classList.add("active");
		});

		container.addEventListener("mouseleave", () => {
			isDown = false;
			container.classList.remove("active");
		});

		container.addEventListener("mouseup", () => {
			isDown = false;
			container.classList.remove("active");
		});

		container.addEventListener("mousemove", (e) => {
			if (!isDown) return;
			e.preventDefault();
			const x = e.pageX - container.offsetLeft;
			const walk = (x - startX) * 3;
			container.scrollLeft = scrollLeft - walk;
		});

		// For mobile devices
		container.addEventListener("touchstart", (e) => {
			isDown = true;
			startX = e.touches[0].pageX - container.offsetLeft;
			scrollLeft = container.scrollLeft;
			container.classList.add("active");
		});

		container.addEventListener("touchmove", (e) => {
			if (!isDown) return;
			e.preventDefault();
			const x = e.touches[0].pageX - container.offsetLeft;
			const walk = (x - startX) * 3;
			container.scrollLeft = scrollLeft - walk;
		});

		container.addEventListener("touchend", () => {
			isDown = false;
			container.classList.remove("active");
		});

		container.addEventListener("touchcancel", () => {
			isDown = false;
			container.classList.remove("active");
		});
	};
	const switchSpecialType = (keyVal, specialKey) => {
		if (keyVal === 1) {
			return "بسته اینترنت";
		}
		if (keyVal === 2) {
			return "بسته ترکیبی";
		}
		if (specialKey === 2) {
			return "رومینگ عراق";
		}
		if (specialKey === 3) {
			return "رومینگ امارات";
		}
		if (specialKey === 1) {
			return "رومینگ ترکیه";
		}
	};

	return (
		<>
			<Helmet>
				<title>بسته‌های اینترنت آپتل</title>
				<meta name="description" content="خرید بسته های مقرون به صرفه" />
				<meta name="keywords" content="خرید بسته آپتل، خرید بسته گردشگری ، خرید بسته ترکی، خرید بسته ارزان، خرید بسته اینترنت" />
			</Helmet>
			<div className="packages pt-4 pb-4">
				<div className="container">
					<div className="row">
						<div className="col-xl-3 col-lg-4">
							<div className="scroll-fix">
								<div className="hold-login-msisdn mb-4">
									<div className="hold-box-category">
										<div className="box-show">
											<div className="header">
												<h3>ورود شماره آپتلی</h3>
											</div>
											<div className="body">
												<div className="entry-msisdn">
													<p>جهت مشاهده بسته‌های بیش‌تر و بسته‌های ویژه شماره خود را وارد نمایید.</p>
													<form onSubmit={formik.handleSubmit}>
														<div className="holder-button-input">
															<div className="row-item">
																<div className="hold-prefix">
																	<span className="prefix">0999</span>
																	<InputMask
																		mask="999 99 99"
																		placeholder="-- -- --"
																		value={formik.values.msisdn}
																		onChange={(e) => {
																			e.target.value = convertPersian(e.target.value);
																			formik.handleChange(e);
																		}}
																		autoComplete="off"
																		onBlur={formik.handleBlur}
																		type="text"
																		inputMode="numeric"
																		id="msisdn"
																		name="msisdn"
																		dir="ltr"
																		className="form-control"
																	/>
																</div>
																<div className="hold-button">
																	<button type="submit" className="btn btn-normal">
																		ادامه
																	</button>
																</div>
															</div>
														</div>
														{formik.touched.msisdn && formik.errors.msisdn ? (
															<span className="error invalid-feedback" style={{ display: "inline" }}>
																{formik.errors.msisdn}
															</span>
														) : (
															""
														)}
													</form>
												</div>
											</div>
										</div>
									</div>
								</div>
								<div className="holder-category d-md-none d-lg-block d-sm-none d-md-block d-none d-sm-block">
									{category.map((item, key) => {
										return (
											<div key={key} className="hold-box-category">
												<div className="box-show">
													<div className="header">
														<h3>{item.productGroupName}</h3>
													</div>
													<div className="body">
														<ul className="list-unstyled">
															{item.subgroup.map((sIndex, sKey) => {
																return (
																	<li
																		key={sKey}
																		className={parseInt(currentFilterActive.id) === sIndex.inT_ProductSubGroupId ? "active" : ""}
																		data-value={sIndex.inT_ProductSubGroupId}
																		data-name={sIndex.stR_ProductSubGroupName}
																		onClick={handleChangeFilter}>
																		{sIndex.stR_ProductSubGroupName}
																	</li>
																);
															})}
														</ul>
													</div>
												</div>
											</div>
										);
									})}
								</div>
							</div>
						</div>
						<div className="col-xl-9 col-lg-8">
							<div className="holder-filter-by-order">
								<div className="row-order-show">
									<div className="filter-reponse" ref={refCategoryScroll}>
										<ul className="list-unstyled">
											{category.map((item, key) => {
												return (
													<li key={key}>
														<div className="row-item">
															<div className="btn-group">
																<button type="button" className="btn dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
																	<div className="row-filter">
																		<div className="hold-fix">
																			{item.productGroupName}
																			{" : "}
																		</div>
																		<div className="hold-choose">
																			{item.subgroup.some((sub) => sub.inT_ProductSubGroupId === parseInt(currentFilterActive.id)) && (
																				<>{currentFilterActive.name}</>
																			)}
																		</div>
																	</div>
																</button>
																<ul className="dropdown-menu">
																	{item.subgroup.map((sitem, skey) => {
																		return (
																			<li key={skey}>
																				<a
																					href="#"
																					className={
																						parseInt(currentFilterActive.id) === sitem.inT_ProductSubGroupId
																							? "dropdown-item active"
																							: "dropdown-item"
																					}
																					data-value={sitem.inT_ProductSubGroupId}
																					data-name={sitem.stR_ProductSubGroupName}
																					onClick={handleChangeFilter}>
																					{sitem.stR_ProductSubGroupName}
																				</a>
																			</li>
																		);
																	})}
																</ul>
															</div>
														</div>
													</li>
												);
											})}
										</ul>
									</div>
									<div className="holder-show-prefer">
										<div className="row-prefer">
											<div className="hold-fix">
												<span> مرتب سازی بر اساس:</span>
											</div>
											<div className="hold-list">
												<div className="btn-group">
													<button type="button" className="btn dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
														{orderSelected.name}
													</button>
													<ul className="dropdown-menu">
														{orderShow.map((index, key) => {
															return (
																<li key={key}>
																	<a
																		className={orderSelected.id === index.id ? "dropdown-item active" : "dropdown-item "}
																		href="#"
																		onClick={handleChangeOrder}
																		data-name={index.name}
																		data-id={index.id}>
																		{index.name}
																	</a>
																</li>
															);
														})}
													</ul>
												</div>
											</div>
										</div>
									</div>
									<div className="holder-show-item">
										<ul className="list-unstyled show-list-view">
											<li>
												<i
													className={`icon-view-column ${showGrid && "active"}`}
													onClick={() => {
														setShowGrid(true);
														setCookie("showGridPackage", true, {
															path: "/",
															expires: new Date("9999-12-31"),
														});
													}}></i>
											</li>
											<li>
												<i
													className={`icon-view-row ${!showGrid && "active"}`}
													onClick={() => {
														setShowGrid(false);
														setCookie("showGridPackage", false, {
															path: "/",
															expires: new Date("9999-12-31"),
														});
													}}></i>
											</li>
										</ul>
									</div>
								</div>
							</div>
							<div className="holder-packages pb-3">
								{isLoading ? (
									showGrid ? (
										<LoadingPackagesColumn />
									) : (
										<LoadingPackagesRows />
									)
								) : (
									<>
										{showGrid ? (
											<>
												{packagesOffers.length > 0 && (
													<div className="show-offers_packages">
														<h3>بسته ویژه</h3>
														<div className="row">
															{packagesOffers.map((item, key) => {
																return (
																	<div key={key} className="col-xl-4 col-lg-6 col-md-6 mb-4">
																		<div className="item">
																			<div
																				className="head"
																				data-type={item.packageType === 1 ? "internet" : item.packageType === 2 ? "combo" : "roming"}>
																				<h3>{switchSpecialType(item.packageType, item.specialPackageType)}</h3>
																			</div>
																			<div className="body">
																				<div className="holder-title">
																					<h3>{item.packageName}</h3>

																					<span>{item.packageBillingType === "0" ? <>اعتباری</> : <>دائمی</>}</span>
																					<br />
																					<span>کد رگولاتوری: {item?.urlcraCode ? <a target="_blank" href={`${item?.urlcraCode}`}>{item?.craCode}</a> : item?.craCode || "-"}</span>
																				</div>
																				{item.voiceCallInDoorDescription !== "0 دقیقه" &&
																					item.voiceCallOutDoorDescription !== "0 دقیقه" &&
																					item.smsDescription !== "0 عدد" &&
																					item.smsDescription !== "0" && (
																						<div className="holder-show-option">
																							{item.voiceCallInDoorDescription !== "0 دقیقه" && (
																								<div className="item">
																									<span className="label">{item.voiceCallInDoorDescription}</span>
																									<span className="value">
																										{item.packageType === 12 ? <>مکالمه با خطوط ترکیه</> : <>مکالمه آپتلی و غیرآپتلی</>}
																									</span>
																								</div>
																							)}
																							{/* {item.voiceCallOutDoorDescription !==
                                        "0 دقیقه" && (
                                        <div className="item">
                                          <span className="label">
                                            {item.voiceCallOutDoorDescription}
                                          </span>
                                          <span className="value">
                                            مکالمه غیرآپتلی
                                          </span>
                                        </div>
                                      )} */}
																							{item.smsDescription !== "0 عدد" && item.smsDescription !== "0" && (
																								<div className="item">
																									<span className="label">{item.smsDescription}</span>
																									<span className="value">{item.packageType === 12 ? <>پیامک به ایران</> : <>پیامک</>}</span>
																								</div>
																							)}
																						</div>
																					)}
																			</div>
																			<div className="footer">
																				<div className="row-item">
																					<div className="hold-price">
																						<h3>
																							<>
																								<span className="new" dir="ltr">
																									{complexDigitToman(item.packagePrice || 0)}
																								</span>{" "}
																								تومان
																							</>
																						</h3>
																					</div>
																					<div className="hold-button">
																						<button className="btn" data-object={JSON.stringify(item)} onClick={handleChoosePackage}>
																							فعال‌سازی
																						</button>
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																);
															})}
														</div>
													</div>
												)}
												<div className="row">
													{packages.map((item, key) => {
														return (
															<div key={key} className="col-xl-4 col-lg-6 col-md-6 mb-4">
																<div className="item">
																	<div className="head" data-type={item.packageType === 1 ? "internet" : item.packageType === 2 ? "combo" : "roming"}>
																		<h3>{switchSpecialType(item.packageType, item.specialPackageType)}</h3>
																	</div>
																	<div className="body">
																		<div className="holder-title">
																			<h3>{item.packageName}</h3>

																			<span>{item.packageBillingType === "0" ? <>اعتباری</> : <>دائمی</>}</span>
																			<br />
																			<span>کد رگولاتوری: {item?.urlcraCode ? <a target="_blank" href={`${item?.urlcraCode}`}>{item?.craCode}</a> : item?.craCode || "-"}</span>
																		</div>
																		{item.voiceCallInDoorDescription !== "0 دقیقه" &&
																			item.voiceCallOutDoorDescription !== "0 دقیقه" &&
																			item.smsDescription !== "0 عدد" &&
																			item.smsDescription !== "0" && (
																				<div className="holder-show-option">
																					{item.voiceCallInDoorDescription !== "0 دقیقه" && (
																						<div className="item">
																							<span className="label">{item.voiceCallInDoorDescription}</span>
																							<span className="value">
																								{item.packageType === 12 ? <>مکالمه با خطوط ترکیه</> : <>مکالمه آپتلی و غیرآپتلی</>}
																							</span>
																						</div>
																					)}
																					{/* {item.voiceCallOutDoorDescription !==
                                        "0 دقیقه" && (
                                        <div className="item">
                                          <span className="label">
                                            {item.voiceCallOutDoorDescription}
                                          </span>
                                          <span className="value">
                                            مکالمه غیرآپتلی
                                          </span>
                                        </div>
                                      )} */}
																					{item.smsDescription !== "0 عدد" && item.smsDescription !== "0" && (
																						<div className="item">
																							<span className="label">{item.smsDescription}</span>
																							<span className="value">{item.packageType === 12 ? <>پیامک به ایران</> : <>پیامک</>}</span>
																						</div>
																					)}
																				</div>
																			)}
																	</div>
																	<div className="footer">
																		<div className="row-item">
																			<div className="hold-price">
																				<h3>
																					{item?.showBeforePrice != 0 ? (
																						<>
																							<span>
																								<span className="old" dir="ltr">
																									{complexDigitToman(item.showBeforePrice || 0)}
																								</span>
																								<span className="new" dir="ltr">
																									{complexDigitToman(item.packagePrice || 0)}
																								</span>
																							</span>
																							<span>تومان</span>
																						</>
																					) : (
																						<>
																							<span className="new" dir="ltr">
																								{complexDigitToman(item.packagePrice || 0)}
																							</span>{" "}
																							تومان
																						</>
																					)}
																				</h3>
																			</div>
																			<div className="hold-button">
																				<button className="btn" data-object={JSON.stringify(item)} onClick={handleChoosePackage}>
																					فعال‌سازی
																				</button>
																			</div>
																		</div>
																	</div>
																</div>
															</div>
														);
													})}
												</div>
											</>
										) : (
											<>
												{packagesOffers.length > 0 && (
													<div className="show-offers_packages">
														<h3>بسته ویژه</h3>
														<div className="row">
															{packagesOffers.map((item, key) => {
																return (
																	<div key={key} className="col-12 mb-3">
																		<div className="row-item">
																			<div
																				className="holder-small-row"
																				data-type={item.packageType === 1 ? "internet" : item.packageType === 2 ? "combo" : "roming"}
																				data-title={switchSpecialType(item.packageType, item.specialPackageType)}>
																				<div className="hold-show-option">
																					<div className="hold-title">
																						<div className="pre-title">
																							<div className="hold-type">
																								<span> {item.packageBillingType === "0" ? <>اعتباری</> : <>دائمی</>}</span>
																							</div>
																							<h3>{item.packageName}</h3>
																							<span>کد رگولاتوری: {item?.urlcraCode ? <a target="_blank" href={`${item?.urlcraCode}`}>{item?.craCode}</a> : item?.craCode || "-"}</span>
																							<p>
																								{item.voiceCallInDoorDescription !== "0 دقیقه" && (
																									<>
																										{"+"}
																										{item.voiceCallInDoorDescription}
																										{item.packageType === 12 ? <> مکالمه با خطوط ترکیه</> : <> مکالمه آپتلی و غیرآپتلی</>}
																										<br />
																									</>
																								)}
																								{/* {item.voiceCallOutDoorDescription !==
                                              "0 دقیقه" && (
                                              <>
                                                +
                                                {
                                                  item.voiceCallOutDoorDescription
                                                }
                                                <br />
                                              </>
                                            )} */}
																								{item.smsDescription !== "0 عدد" && item.smsDescription !== "0" && (
																									<>
																										+{item.smsDescription}
																										{item.packageType === 12 ? <> پیامک به ایران</> : <> پیامک</>}
																									</>
																								)}
																							</p>
																						</div>
																					</div>
																					<div className="hold-footer">
																						<div className="hold-price">
																							<div className="price">
																								<span className="new">{complexDigitToman(item.packagePrice || 0)}</span> تومان
																							</div>
																						</div>
																						<div className="hold-button">
																							<div className="btn" data-object={JSON.stringify(item)} onClick={handleChoosePackage}>
																								فعال‌سازی
																							</div>
																						</div>
																					</div>
																				</div>
																			</div>
																			<div
																				className="holder-big-row"
																				data-type={item.packageType === 1 ? "internet" : item.packageType === 2 ? "combo" : "roming"}
																				data-title={switchSpecialType(item.packageType, item.specialPackageType)}>
																				<div className="hold-title">
																					<h3>{item.packageName}</h3>
																					<span>کد رگولاتوری: {item?.urlcraCode ? <a target="_blank" href={`${item?.urlcraCode}`}>{item?.craCode}</a> : item?.craCode || "-"}</span>
																					<p>
																						{item.voiceCallInDoorDescription !== "0 دقیقه" && (
																							<>
																								{item.voiceCallInDoorDescription}
																								{item.packageType === 12 ? <> مکالمه با خطوط ترکیه</> : <> مکالمه آپتلی و غیرآپتلی</>}
																								{" , "}
																							</>
																						)}
																						{/* {item.voiceCallOutDoorDescription !==
                                          "0 دقیقه" && (
                                          <>
                                            {item.voiceCallOutDoorDescription}
                                          </>
                                        )} */}
																						{item.smsDescription !== "0 عدد" && item.smsDescription !== "0" && (
																							<>
																								{item.smsDescription}
																								{item.packageType === 12 ? <> پیامک به ایران</> : <> پیامک</>}
																							</>
																						)}
																					</p>
																				</div>
																				<div className="hold-type">
																					<span> {item.packageBillingType === "0" ? <>اعتباری</> : <>دائمی</>}</span>
																				</div>
																				<div className="hold-ussd">
																					<strong dir="ltr">
																						<a href={`tel:${item?.ussd}`}>{item?.ussd}</a>
																					</strong>
																				</div>
																				<div className="hold-price">
																					<strong>
																					
																								<span className="new" dir="ltr">
																									{complexDigitToman(item.packagePrice || 0)}
																								</span>{" "}
																								تومان
																							
																					</strong>
																				</div>
																				<div className="hold-button">
																					<button className="btn" data-object={JSON.stringify(item)} onClick={handleChoosePackage}>
																						فعال‌سازی
																					</button>
																				</div>
																			</div>
																		</div>
																	</div>
																);
															})}
														</div>
													</div>
												)}
												<div className="row">
													{packages.map((item, key) => {
														return (
															<div key={key} className="col-12 mb-3">
																<div className="row-item">
																	<div
																		className="holder-small-row"
																		data-type={item.packageType === 1 ? "internet" : item.packageType === 2 ? "combo" : "roming"}
																		data-title={switchSpecialType(item.packageType, item.specialPackageType)}>
																		<div className="hold-show-option">
																			<div className="hold-title">
																				<div className="pre-title">
																					<div className="hold-type">
																						<span> {item.packageBillingType === "0" ? <>اعتباری</> : <>دائمی</>}</span>
																					</div>
																					<h3>{item.packageName}</h3>
																					<span>کد رگولاتوری: {item?.urlcraCode ? <a target="_blank" href={`${item?.urlcraCode}`}>{item?.craCode}</a> : item?.craCode || "-"}</span>
																					<p>
																						{item.voiceCallInDoorDescription !== "0 دقیقه" && (
																							<>
																								{"+"}
																								{item.voiceCallInDoorDescription}
																								{item.packageType === 12 ? <> مکالمه با خطوط ترکیه</> : <> مکالمه آپتلی و غیرآپتلی</>}
																								<br />
																							</>
																						)}
																						{/* {item.voiceCallOutDoorDescription !==
                                              "0 دقیقه" && (
                                              <>
                                                +
                                                {
                                                  item.voiceCallOutDoorDescription
                                                }
                                                <br />
                                              </>
                                            )} */}
																						{item.smsDescription !== "0 عدد" && item.smsDescription !== "0" && (
																							<>
																								+{item.smsDescription}
																								{item.packageType === 12 ? <> پیامک به ایران</> : <> پیامک</>}
																							</>
																						)}
																					</p>
																				</div>
																			</div>
																			<div className="hold-footer">
																				<div className="hold-price">
																					<div className="price">
																						{item?.showBeforePrice != 0 ? (
																							<>
																								<span>
																									<span className="old" dir="ltr">
																										{complexDigitToman(item.showBeforePrice || 0)}
																									</span>
																									<span className="new">{complexDigitToman(item.packagePrice || 0)}</span>
																								</span>
																								<span>تومان </span>
																							</>
																						) : (
																							<>
																								<span className="new">{complexDigitToman(item.packagePrice || 0)}</span> تومان
																							</>
																						)}
																					</div>
																				</div>
																				<div className="hold-button">
																					<div className="btn" data-object={JSON.stringify(item)} onClick={handleChoosePackage}>
																						فعال‌سازی
																					</div>
																				</div>
																			</div>
																		</div>
																	</div>
																	<div
																		className="holder-big-row"
																		data-type={item.packageType === 1 ? "internet" : item.packageType === 2 ? "combo" : "roming"}
																		data-title={switchSpecialType(item.packageType, item.specialPackageType)}>
																		<div className="hold-title">
																			<h3>{item.packageName}</h3>
																			<span>کد رگولاتوری: {item?.urlcraCode ? <a target="_blank" href={`${item?.urlcraCode}`}>{item?.craCode}</a> : item?.craCode || "-"}</span>
																			<p>
																				{item.voiceCallInDoorDescription !== "0 دقیقه" && (
																					<>
																						{item.voiceCallInDoorDescription}
																						{item.packageType === 12 ? <> مکالمه با خطوط ترکیه</> : <> مکالمه آپتلی و غیرآپتلی</>}
																						{" , "}
																					</>
																				)}
																				{/* {item.voiceCallOutDoorDescription !==
                                          "0 دقیقه" && (
                                          <>
                                            {item.voiceCallOutDoorDescription}
                                          </>
                                        )} */}
																				{item.smsDescription !== "0 عدد" && item.smsDescription !== "0" && (
																					<>
																						{item.smsDescription}
																						{item.packageType === 12 ? <> پیامک به ایران</> : <> پیامک</>}
																					</>
																				)}
																			</p>
																		</div>
																		<div className="hold-type">
																			<span> {item.packageBillingType === "0" ? <>اعتباری</> : <>دائمی</>}</span>
																		</div>
																		<div className="hold-ussd">
																			<strong dir="ltr">
																				<a href={`tel:${item?.ussd}`}>{item?.ussd}</a>
																			</strong>
																		</div>
																		<div className="hold-price">
																			<strong>
																				{item?.showBeforePrice != 0 ? (
																					<>
																						<span>
																							<span className="old" dir="ltr">
																								{complexDigitToman(item.showBeforePrice || 0)}
																							</span>
																							<span className="new" dir="ltr">
																								{complexDigitToman(item.packagePrice || 0)}
																							</span>
																						</span>
																						<span>تومان</span>
																					</>
																				) : (
																					<>
																						<span className="new" dir="ltr">
																							{complexDigitToman(item.packagePrice || 0)}
																						</span>{" "}
																						تومان
																					</>
																				)}
																			</strong>
																		</div>
																		<div className="hold-button">
																			<button className="btn" data-object={JSON.stringify(item)} onClick={handleChoosePackage}>
																				فعال‌سازی
																			</button>
																		</div>
																	</div>
																</div>
															</div>
														);
													})}
												</div>
											</>
										)}
									</>
								)}

								{buttonShowMore && !isLoading && (
									<div className="holder-show-more mt-5">
										<div className="hold-button text-center">
											<button className="btn btn-outline-light" onClick={showPackageWhitoutFilter}>
												مشاهده بیشتر
											</button>
										</div>
									</div>
								)}
							</div>
						</div>
					</div>
				</div>
			</div>
			<ModalConfirm activePackage={choosePackage} msisdn={formik.values.msisdn.replace(/ /g, "").replace(/_/g, "")} />
		</>
	);
};

export default PackageIndex;
